<!--权限模板模式-->
<template>
    <div v-if="isMounted">
        <div class="left m-portlet">
            <div class="m-portlet__body" v-loading="$parentInfo.authorityList.leftLoading">
                <vue-scroll :ops="$ops">
                    <div :style="{'height':(clientHeight-280)+'px'}">
                        <el-row>
                            <el-col :span="9">
                                <el-select v-model="section_id" clearable placeholder="请选择校区" @change="changeSection()"
                                           style="width: 120px">
                                    <el-option
                                            v-for="item in $parentInfo.sections"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <el-select v-model="template_id" clearable placeholder="请选择模板" filterable remote
                                           :remote-method="handleSearchTemplate" @change="handleIndexPowerTemplate()">
                                    <el-option
                                            v-for="item in $parentInfo.authorityList.searchTemplates"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>模板名称</th>
                                <th width="20">删除</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item,index) in $parentInfo.authorityList.powerTemplates" :key="index">
                                <td>{{item.name}}</td>
                                <td>
                                    <el-button type="danger" icon="el-icon-delete" size="mini" circle
                                               @click="handleDestroyPowerTemplate(item.id)"
                                               :loading="$parentInfo.authorityList.button_loading"></el-button>
                                </td>
                                <td>
                                    <el-row>
                                        <el-col :span="12">
                                            <el-button size="mini" @click="handleToPowerTemplate(item.id)">模板
                                            </el-button>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-button v-if="index===clickIndex" @click="handleCancel()" type="danger"
                                                       size="mini">关闭
                                            </el-button>
                                            <el-button v-else size="mini"
                                                       @click="handleToEmployee(item.id,item.section_id,index,item.name)">
                                                展开
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </vue-scroll>
            </div>
        </div>
        <div class="right m-portlet">
            <div class="m-portlet__body" v-loading="$parentInfo.authorityList.rightLoading">
                <vue-scroll :ops="$ops">
                        <div :style="{'height':(clientHeight-280)+'px'}">
                            <el-row v-if="powerTemplate_id!==''">
                                <el-col :span="12">
                                    <div style="margin-top: 5px"><b>模板名称：{{checkedPowerTemplate}}</b>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div align="right">
                                        <el-popover placement="left" trigger="click" width="280">
                                            <el-row :gutter="24">
                                                <el-col :span="16">
                                                    <el-select v-model="addEmployee"
                                                               placeholder="请选择员工"
                                                               :remote-method="handleSearchEmployee"
                                                               :loading="$parentInfo.search_loading"
                                                               style="width: 150px;"
                                                               clearable
                                                               filterable
                                                               remote
                                                               multiple>
                                                        <el-option
                                                                v-for="item in $parentInfo.authorityList.searchEmployees"
                                                                :key="item.id"
                                                                :label="item.name"
                                                                :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                                <el-col :span="8">
                                                    <el-button @click="handleAddEmployee()"
                                                               :loading="$parentInfo.authorityList.button_loading">提交
                                                    </el-button>
                                                </el-col>
                                            </el-row>
                                            <el-button size="mini" slot="reference">模板中添加员工</el-button>
                                        </el-popover>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-select v-else
                                       v-model="employee"
                                       placeholder="请选择员工"
                                       :remote-method="handleSearchEmployee"
                                       @change="handleEmployeeIndex(1,10)"
                                       :loading="$parentInfo.search_loading"
                                       clearable
                                       filterable
                                       remote>
                                <el-option
                                        v-for="item in $parentInfo.authorityList.searchEmployees"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>

                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th>姓名</th>
                                    <th>账号</th>
                                    <th>角色</th>
                                    <th>状态</th>
                                    <th>操作</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in $parentInfo.authorityList.employees" :key="index">
                                    <td>{{item.name}}</td>
                                    <td v-if="item.account_number==='发送注册'">
                                        <el-button @click="handleSendRegister(item.id)">{{item.account_number}}</el-button>
                                    </td>
                                    <td v-else>{{item.account_number}}</td>
                                    <td>
                                    <span v-for="identity in item.identity">
                                         <el-button size="mini" @click="handleJump(identity)"
                                                    style="background-color: hsla(220,4%,58%,.1);border-color: hsla(220,4%,58%,.2);color: #909399;margin: 0 2px">
                                           {{identity}}
                                        </el-button>
                                    </span>
                                    </td>
                                    <td v-if="item.status">在职</td>
                                    <td v-else>离职</td>

                                    <td>
                                        <el-button @click="handleUpdateTemplate(item.id)">查看权限</el-button>
                                        <el-button @click="handleUpdateEmployee(item)">修改</el-button>
                                        <el-button @click="handleUpdateAccount(item.id)">修改账号</el-button>
                                        <el-button v-if="powerTemplate_id!==''" type="danger" icon="el-icon-delete"
                                                   size="mini"
                                                   circle
                                                   @click="handleDestroyPowerTemplateEmployee(item.id)"
                                                   :loading="$parentInfo.authorityList.button_loading"></el-button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <!--分页-->
                            <div class="text-center m-t-10">
                                <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="currentPage"
                                        :page-sizes="[10, 20, 50, 100]"
                                        :page-size="10"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="$parentInfo.authorityList.total">
                                </el-pagination>
                            </div>
                        </div>
                    </vue-scroll>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .left {
        float: left;
        width: 400px;
    }

    .right {
        margin-left: 405px;
    }
</style>

<script>
    export default {
        name: 'AuthorityList',
        data() {
            return {
                powerTemplate_id: '',
                power_section: '',
                section_id: '',
                template_id: '',
                clickIndex: '',
                employees: [],
                addEmployee: [],
                employee: '',
                employee_id: '',
                currentPage: 1,
                currentPageSize: 10,
                checkedPowerTemplate: '',
                isMounted: false,
            }
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            powers(){
                return this.$store.state.config.powers;
            }
        },
        mounted() {
            this.isMounted = true;
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleIndexPowerTemplate();
            this.handleSearchTemplate("");
            this.handleEmployeeIndex();
            this.handleSearchEmployee("");
        },
        methods: {
            //筛选校区
            changeSection() {
                this.$nextTick(() => {
                    this.handleSearchTemplate("");
                });
                this.handleIndexPowerTemplate();
            },
            //筛选模板
            handleSearchTemplate(query) {
                this.$parentInfo.search_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'search_employeeAndTemplate', {
                    'searchKey': query,
                    'section_id': this.section_id,
                    'type': 'searchTemplate',
                });
            },
            //筛选员工
            handleSearchEmployee(query) {
                this.$parentInfo.search_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'search_employeeAndTemplate', {
                    'searchKey': query,
                    'section_id': this.section_id,
                    'type': 'searchEmployee',
                });
            },
            //前往模板中的员工
            handleToEmployee(id, section_id, index, name) {
                this.clickIndex = index;
                this.powerTemplate_id = id;
                this.power_section = section_id;
                this.checkedPowerTemplate = name;
                this.$parentInfo.authorityList.rightLoading = true;
                this.employee = '';
                this.handleTemplateShow();
                this.handleEmployeeIndex();
            },
            //恢复默认员工列表
            handleCancel() {
                this.clickIndex = '';
                this.powerTemplate_id = '';
                this.employee = '';
                this.$parentInfo.authorityList.rightLoading = true;
                this.$nextTick(() => {
                    this.handleEmployeeIndex();
                })
            },
            //模板列表
            handleIndexPowerTemplate() {
                this.$wApi.send(this.$parentInfo.path, 'get_powerTemplateList', {
                    'section_id': this.section_id,
                    'template_id': this.template_id
                });
            },
            //员工列表
            handleEmployeeIndex(currentPage = 1, currentPageSize = 10) {
                if (this.powerTemplate_id !== '') {
                    this.$wApi.send(this.$parentInfo.path, 'get_employeeIndex', {
                        'id': this.powerTemplate_id,
                        'employee_id': this.employee,
                    });
                } else {
                    this.$wApi.send(this.$parentInfo.path, 'get_employeePowerTemplateList', {
                        'currentPage': currentPage,
                        'currentPageSize': currentPageSize,
                        'employee_id': this.employee,
                    });
                }
            },
            //选中模板展示
            handleTemplateShow() {
                this.$wApi.send(this.$parentInfo.path, 'get_powerTemplateList', {
                    'section_id': this.section_id,
                    'template_id': this.template_id
                });
            },
            //添加模板中的员工
            handleAddEmployee() {
                this.$parentInfo.authorityList.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'give_employee_to_template', {
                    'id': this.powerTemplate_id,
                    'addEmployee': this.addEmployee,
                });
            },
            //删除模板
            handleDestroyPowerTemplate(id) {
                this.$parentInfo.authorityList.button_loading = true;
                this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'delete_powerTemplate', {
                        'id': id,
                    });
                    if (this.powerTemplate_id === id) {
                        this.$parentInfo.authorityList.rightLoading = true;
                    }
                }).catch(() => {
                    this.$parentInfo.authorityList.button_loading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //删除模板中的员工
            handleDestroyPowerTemplateEmployee(employee_id) {
                this.$parentInfo.authorityList.button_loading = true;
                this.$confirm('此操作将永久删除该模板中员工, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'delete_employee_from_powerTemplate', {
                        'employee_id': employee_id,
                        'id': this.powerTemplate_id,
                    });
                }).catch(() => {
                    this.$parentInfo.authorityList.button_loading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //查看模板权限
            handleToPowerTemplate(id) {
                this.$Win.openModal('Dialog_UpdatePowerTemplate', 1024, 900, '查看权限模板', {
                    'id': id,
                });
            },
            //修改员工权限
            handleUpdateTemplate(id) {
                this.$Win.openModal('Dialog_TemplateUpdateEmployeePower', 1024, 900, '查看员工权限', {
                    'id': id,
                });
            },

            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleEmployeeIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleEmployeeIndex(this.currentPage, this.currentPageSize)
            },
            handleCancelUser(employee_id,disabled){
                this.$confirm('此操作将注销该账户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'cancel_user', {
                        'employee_id': employee_id,
                        'disabled': disabled,
                    });
                }).catch(() => {
                    this.$parentInfo.authorityList.button_loading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSendRegister(employee_id){
                this.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'set_sms_to_register', {
                    'employee_id': employee_id,

                });
            },
            handleJump(type){
                if(type=='老师'){
                    this.$store.dispatch('addView', {
                        'title': '教师列表',
                        'path': '/teacher/list',
                        'closable': true
                    });
                    this.router.push({path: '/teacher/list'})
                }else if(type=='班主任'){
                    return 0;
                }
            },
            handleUpdateEmployee(employee){
                this.$Win.openModal('Dialog_UpdateEmployee',  750, 700, '修改员工信息', {
                    'employee': employee,
                });
            },
            handleUpdateAccount(employee_id){
                this.$Win.openModal('Dialog_UpdateAccount', 400, 800, '修改账号',{'employee_id':employee_id});
            }
        }
    }
</script>
